import { render, staticRenderFns } from "./SnackbarTemplate.vue?vue&type=template&id=6dace938"
import script from "./SnackbarTemplate.vue?vue&type=script&lang=js"
export * from "./SnackbarTemplate.vue?vue&type=script&lang=js"
import style0 from "./SnackbarTemplate.vue?vue&type=style&index=0&id=6dace938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports